import { NavLink } from "react-router-dom";
import styled from "@emotion/styled/macro";
import { useTranslation } from "react-i18next";

const MenuItem = styled.li`
  @media (min-width: ${({ theme }) => theme.breakpoints.md}) {
    padding: 0 ${({ theme }) => theme.layout.header.menu.secondaryMenuSpacing}
  };
  font-family: ${({ theme }) => theme.fonts.secondMenu};
  font-size: ${({ theme }) => theme.fontSizes.md};
  color: ${({ theme }) => theme.colors.opal};
  a {
    user-select: none;
  }
}
`;

export const secondaryMenuItems = [
  { link: "/about", label: "header.secondaryMenu.about" },
  { link: "/faq", label: "header.secondaryMenu.faq" },
  { link: "/legal", label: "header.secondaryMenu.legal" },
  { link: "/contact", label: "header.secondaryMenu.contact" },
];

const SecondaryMenu = ({ onClose }) => {
  const { t } = useTranslation();

  return (
    <ul>
      {secondaryMenuItems.map((item, key) => (
        <MenuItem>
          <NavLink to={item.link} activeClassName="selected" onClick={onClose} key={key}>
            {t(item.label)}
          </NavLink>
        </MenuItem>
      ))}
    </ul>
  );
};

export default SecondaryMenu;
